import { FormFieldTypes } from "../../../../../components/forms/libs/data/formFieldType";

const initState = {
    effectiveDate: null,
    status: null,
    date: null,
    paymentCategory: null,
  };
  
export const CancelBookingEventDataFile = {
    name: "CancelBookingEventDataFile",
    initialState: initState,
    section: [
      {
        title: "CancelBookingEventDataFile",
        row: {},
        style: {
          sectionStyle: "row verticle-form",
        },
        rowGroup: [
          {
            groupLabel: "CancelBookingEventDataFile",
            style: {
              groupStyle: "col-lg-12 col-md-12 mb-2",
            },
            groupWrapper: <div className="form-card row"></div>,
            fields: [
              {
                id: "effectiveDate",
                label: "Effective Date",
                Field_Name: "EffectiveDate",
                fieldType: FormFieldTypes.DATEPICKER,
                dataField: "effectiveDate",
                fieldSetting: {
                  allowSpace: false,
                },
                style: {
                  containerCss: "col-lg-6 col-md-6",
                },
              },
              {
                id: "cancellationReason",
                label: "Cancellation Reason",
                Field_Name: "Cancellation Reason",
                fieldType: FormFieldTypes.SELECT,
                dataField: "cancellationReason",
                fieldSetting: {
                  placeholder: "Select",
                  options: [
                  ],
                },
                style: {
                  containerCss: "col-lg-6 col-md-6 validation-left-0 ",
                },
              },
            ],
          },
        ],
  
      },
    ],
  };